import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../environments/environment';


@Pipe({name: 'commaSeperatedPrice'})

export class CommaSeperatedPricePipe implements PipeTransform {
	env = environment;
	
	transform(amount: any): any {
		if (!amount || isNaN(amount)) {
            return amount;
        } else {

            let multiplier = Math.pow(10, 2 || 0);
			amount = Math.round(amount * multiplier) / multiplier;
            amount = amount.toString();
            let afterPoint = '';
        
            if (amount.indexOf('.') > 0) afterPoint = amount.substring(amount.indexOf('.'), amount.length);
            amount = Math.floor(amount);
            amount = amount.toString();
            
            let lastThree = amount.substring(amount.length - 3);
            let otherNumbers = amount.substring(0, amount.length - 3);
            if (otherNumbers != '') lastThree = ',' + lastThree;
            let finalAmount = otherNumbers.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + lastThree + afterPoint;
        
            return  finalAmount;
        }
	}
}
